<script setup>
// Settings — the user-owned settings hub. Houses Device check (live) plus
// Preferences and Notifications (placeholders) for future growth.
//
// Sibling of QuizzesShell.vue — same pattern (PageTabs strip + nested
// router-view). Lives under ConsumerShell, so the surrounding chrome
// (sidebar + topbar) comes from ConsumerLayout.
import PageTabs from "@digitalstreams/saas-core/vue/layouts/PageTabs.vue";

const tabs = [
  { label: "Device check",   to: "/settings",               icon: "bi bi-mic-fill",       exact: true },
  { label: "Preferences",    to: "/settings/preferences",   icon: "bi bi-sliders" },
  { label: "Notifications",  to: "/settings/notifications", icon: "bi bi-bell" },
  // Workspace content policy (tenant-admin) — e.g. turn content review off for a
  // curated knowledge base. i-Recall surface (GET/POST /api/library/settings).
  { label: "Library",        to: "/settings/library",       icon: "bi bi-collection" },
  // Tenant-admin surface (saas-core TenantSettings) — organization details +
  // branding for the user's workspace. The API rejects non-admin members;
  // every i-Recall user is tenant_admin of their own personal workspace.
  { label: "Organization",   to: "/settings/organization",  icon: "bi bi-building" }
];
</script>

<template>
  <div class="container-fluid p-0">
    <h1 class="h3 mb-1">Settings</h1>
    <p class="text-muted mb-3">
      Your preferences and device checks for the voice quiz.
    </p>

    <PageTabs :tabs="tabs" />

    <router-view />
  </div>
</template>
